import * as React from 'react';
const SvgIconArrowExpand = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8V0H10L13.29 3.29L3.29 13.29L0 10V18H8L4.71 14.71L14.71 4.71L18 8Z" fill="currentColor" />
  </svg>
);
export default SvgIconArrowExpand;
